const itemGroup = [
  {
    group: '総SKU',
    item: [
      { name: '総SKU数', description: 'JANコード単位の商品数.廃番と共通商品は除く' },
      {
        name: '総SKU/自社',
        description: '総SKUの内、商品台帳の他社／自社が「3:自社商品」に設定されている商品数',
      },
      {
        name: '総SKU/他社',
        description:
          '総SKUの内、商品台帳の他社／自社が「1:他社商品(買取)」「2:他社商品(委託)」に設定されている商品数',
      },
    ],
  },
  {
    group: '直近新商品SKU',
    item: [
      {
        name: '直近新商品SKU数',
        description: '総SKU数の内、商品分類３の年月が直近1年間に設定されている商品数',
      },
      {
        name: '直近新商品SKU/自社',
        description: '新商品SKUの内、商品台帳の他社／自社が「3:自社商品」に設定されている商品数',
      },
      {
        name: '直近新商品SKU/自社-売上金額',
        description: '直近新商品SKU/自社の直近1年間売上額',
      },
      {
        name: '直近新商品SKU/自社-売上構成比',
        description: '直近新商品SKU/自社-売上金額 ÷ 総SKUの直近1年間売上額 × 100',
      },
      {
        name: '直近新商品SKU/他社',
        description:
          '新商品SKUの内、商品台帳の他社／自社が「1:他社商品(買取)」「2:他社商品(委託)」に設定されている商品数',
      },
      {
        name: '直近新商品構成比',
        description: '直近新商品SKU ÷ 総SKU × 100',
      },
      {
        name: '直近新商品売上金額',
        description: '直近新商品SKUの売上額',
      },
      {
        name: '直近新商品売上構成比',
        description: '直近新商品売上金額 ÷ 総SKUの直近売上額 × 100',
      },
    ],
  },
  {
    group: '今期新商品SKU',
    item: [
      {
        name: '今期新商品SKU数',
        description: '総SKUの内、商品分類３の年月が今期に設定されている商品数',
      },
      {
        name: '今期新商品SKU/自社',
        description: '新商品SKUの内、商品台帳の他社／自社が「3:自社商品」に設定されている商品数',
      },
      {
        name: '今期新商品SKU/自社-売上金額',
        description: '今期新商品SKU/自社の今期売上額',
      },
      {
        name: '今期新商品SKU/自社-売上構成比',
        description: '今期新商品SKU/自社-売上金額 ÷ 総SKUの今期売上額 × 100',
      },
      {
        name: '今期新商品SKU/他社',
        description:
          '新商品SKUの内、商品台帳の他社／自社が「1:他社商品(買取)」「2:他社商品(委託)」に設定されている商品数',
      },
      {
        name: '今期新商品構成比',
        description: '今期新商品SKU ÷ 総SKU × 100',
      },
      {
        name: '今期新商品売上金額',
        description: '今期新商品SKUの今期売上額',
      },
      {
        name: '今期新商品売上構成比',
        description: '今期新商品売上金額 ÷ 総SKUの今期売上額 × 100',
      },
    ],
  },
  {
    group: 'DIO分析',
    item: [
      {
        name: '前々期DIO',
        description: '前々期末在庫金額 ÷ (前々期年間売上原価 ÷ 365)',
      },
      {
        name: '前期DIO',
        description: '前期末在庫金額 ÷ (前期年間売上原価 ÷ 365)',
      },
      {
        name: '直近DIO',
        description: '直近末在庫金額 ÷ (直近年間売上原価 ÷ 365)',
      },
    ],
  },
  {
    group: 'その他過去実績',
    item: [
      {
        name: '前々期原価率(％)',
        description: '前々期年間売上原価 ÷ 前々期年間税抜売上額 × 100',
      },
      {
        name: '前期原価率(％)',
        description: '前期年間売上原価 ÷ 前期年間税抜売上額 × 100',
      },
      {
        name: '今期原価率(％)',
        description: '今期年間売上原価 ÷ 今期年間税抜売上額 × 100',
      },
      {
        name: '前々期粗利率(％)',
        description: '(前々期年間税抜売上額－前々期年間売上原価) ÷ 前々期年間税抜売上額 × 100',
      },
      {
        name: '前期粗利率(％)',
        description: '(前期年間税抜売上額－前期年間売上原価) ÷ 前期年間税抜売上額 × 100',
      },
      {
        name: '今期粗利率(％)',
        description: '(今期年間税抜売上額－今期年間売上原価) ÷ 今期年間税抜売上額 × 100',
      },
      { name: '目標粗利率(％)', description: '部門台帳の今期の目標粗利率' },
      { name: '過去最高売上', description: '会計期年間売上額の内の最大値' },
      { name: '前々期売上', description: '前々期年間税抜売上額' },
      { name: '前期売上', description: '前期年間税抜売上額' },
      { name: '今期累計売上', description: '今期税抜売上額' },
      { name: '前々期廃盤累計', description: '廃番商品の前々期末在庫金額' },
      { name: '前期廃盤累計', description: '廃番商品の前期末在庫金額' },
      { name: '今期廃盤累計', description: '廃番商品の現在在庫金額' },
    ],
  },
];

export const ItemDescriptionTable = () => (
  <>
    <div className="overflow-x-auto">
      <table className="min-w-[700px] table-auto border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="px-4 py-2 text-left w-52">グループ</th>
            <th className="px-4 py-2 text-left w-72">項目名</th>
            <th className="px-4 py-2 text-left">説明・計算式</th>
          </tr>
        </thead>
        <tbody>
          {itemGroup.map((group) =>
            group.item.map((item, idx) => (
              <tr key={group.group + item.name}>
                {idx === 0 && (
                  <td
                    className="border px-4 py-2 bg-blue-50 font-bold align-top"
                    rowSpan={group.item.length}
                  >
                    {group.group}
                  </td>
                )}
                <td className="border px-4 py-2">{item.name}</td>
                <td className="border px-4 py-2">{item.description}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </>
);
